(function() {
	/******************
		* This is a basic wrapper around Axios for use in a project (AJAX requests)
		* Axios is a promised based XHR framework, its pretty easy to use,
		* but detailed instructions can be found here: https://github.com/axios/axios
		* Usage Example:
			http.get('/api/someData')
				.then(res => {
					//request succeeded, do something with response
					console.log(`The response from the API is ${res}`)
				})
				.catch(err => {
					//request failed, do something with the error
					console.error(`There was an error: ${err}`)
				})
				.finally(() => {
					//do something always, regardless of success or failure 
				})

	******************/
	const http = blue.meth.http = {
		get: (url) => {
			return axios.get(url).then(res => {
				if (res) {
					return res['data'] ? res.data : {}
				}
			})
		},
		delete: (url) => {
			return axios.delete(url).then(res => {
				if (res) {
					return res['data'] ? res.data : {}
				}
			})
		},
		post: (url, data) => {
			return axios.post(url, data).then(res => {
				if (res) {
					return res['data'] ? res.data : {}
				}
			})
		},
		put: (url, data) => {
			return axios.put(url, data).then(res => {
				if (res) {
					return res['data'] ? res.data : {}
				}
			})
		}
	}
})();